// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import HairMedicinePage from "../pages/HairMedicine/HairMedicine";
const __wvcRoutePaths = ["/HairMedicinePage", "/medicina-capilar"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["casos-de-exito", "cirugia-capilar", "contacto", "contactpage", "dra-soto", "drsotopage", "hairmedicinepage", "hairsurgerypage", "homepage", "inicio", "medicina-capilar", "post", "successstoriespage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<HairMedicinePage />} />
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<HairMedicinePage />} />
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
